import React, { useCallback, useEffect, useState } from 'react';
import { API, axios } from '../../utils/api';
import Icona from '../cliente/Icone';
import { quandoBreve } from './comuni';

// Impostazioni → Accessi (solo admin): chi ha aperto o scaricato cosa — documenti, link di banche e notai, zip,
// fascicoli, esportazioni dei dati dei clienti. Filtri per cliente, date e azione.

const CHI = { cliente: 'cliente', admin: 'admin', collaboratore: 'collaboratore', esterno: 'banca / notaio', sistema: 'MK Client' };
const VUOTI = { cliente_id: '', dal: '', al: '', azione: '' };

const Accessi = () => {
  const [clienti, setClienti] = useState([]);
  const [filtri, setFiltri] = useState(VUOTI);
  const [dati, setDati] = useState(null);
  useEffect(() => { axios.get(`${API}/clienti-lista`).then((r) => setClienti(r.data.righe || [])).catch(() => {}); }, []);
  const carica = useCallback(() => {
    const params = Object.fromEntries(Object.entries(filtri).filter(([, v]) => v));
    axios.get(`${API}/admin/accessi`, { params }).then((r) => setDati(r.data)).catch(() => setDati({ righe: [], azioni: {} }));
  }, [filtri]);
  useEffect(() => { carica(); }, [carica]);
  const cambia = (k) => (e) => setFiltri({ ...filtri, [k]: e.target.value });
  return (
    <section className="card" data-testid="accessi">
      <div className="ttl"><div className="i"><Icona nome="chiave" /></div><h2>Registro degli accessi {dati ? <small>{dati.righe.length}{dati.troncato ? '+' : ''}</small> : null}</h2></div>
      <div className="riga-filtri">
        <select value={filtri.cliente_id} onChange={cambia('cliente_id')} aria-label="Cliente">
          <option value="">Tutti i clienti</option>
          {clienti.map((c) => <option key={c.id} value={c.id}>{c.nome_intero || c.nome}</option>)}
        </select>
        <label>dal <input type="date" value={filtri.dal} onChange={cambia('dal')} aria-label="Dal" /></label>
        <label>al <input type="date" value={filtri.al} onChange={cambia('al')} aria-label="Al" /></label>
        <select value={filtri.azione} onChange={cambia('azione')} aria-label="Azione">
          <option value="">Tutte le azioni</option>
          {Object.entries(dati?.azioni || {}).map(([k, t]) => <option key={k} value={k}>{t}</option>)}
        </select>
        {Object.values(filtri).some(Boolean) && <button type="button" className="link" onClick={() => setFiltri(VUOTI)}>Tutto</button>}
      </div>
      {!dati && <p className="vuoto">Carico il registro…</p>}
      {dati && !dati.righe.length && <p className="vuoto">Nessun accesso con questi filtri.</p>}
      {dati && dati.righe.length > 0 && (
        <div className="tabella-box">
          <table className="tabella">
            <thead><tr><th>Quando</th><th>Chi</th><th>Cosa</th><th>Cliente</th><th>IP</th></tr></thead>
            <tbody>
              {dati.righe.map((r, i) => (
                // eslint-disable-next-line react/no-array-index-key
                <tr key={i} data-testid="riga-accesso">
                  <td className="nowrap muto">{quandoBreve(r.quando, true)}</td>
                  <td>{r.chi?.nome || '—'}<small>{CHI[r.chi?.tipo] || r.chi?.tipo}</small></td>
                  <td>{r.azione_testo}{r.documento ? <small>{r.documento.tipo} · {r.documento.nome}</small> : null}
                    {!r.documento && r.dettaglio ? <small>{r.dettaglio}</small> : null}</td>
                  <td>{r.cliente?.nome || '—'}</td>
                  <td className="muto">{r.ip || ''}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      {dati?.troncato && <p className="imp-nota" style={{ marginTop: '.6rem' }}>Mostrati gli ultimi 200: restringete con i filtri.</p>}
    </section>
  );
};

export default Accessi;
